// src/components/mediaKit/ImageUploadField.jsx
import React, { useRef, useState } from 'react';
import { Upload, Loader2, X } from 'lucide-react';
import { mediaKitApi } from '../../services/mediaKitApi';

export default function ImageUploadField({ label, value, onChange, prefix = 'mediakit' }) {
    const inputRef = useRef(null);
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState(null);

    const handleFile = async (file) => {
        if (!file) return;
        setUploading(true);
        setError(null);
        try {
            const { url } = await mediaKitApi.uploadImage(file, prefix);
            onChange(url);
        } catch (e) {
            setError(e.message);
        } finally {
            setUploading(false);
        }
    };

    return (
        <div className="mb-4">
            <span className="block text-sm font-semibold text-slate-700 mb-1.5">{label}</span>
            <div className="flex items-center gap-3">
                <div className="w-16 h-16 rounded-lg bg-slate-100 overflow-hidden shrink-0 flex items-center justify-center border border-slate-200">
                    {value ? <img src={value} className="w-full h-full object-cover" /> : <Upload size={18} className="text-slate-300" />}
                </div>
                <div>
                    <input ref={inputRef} type="file" accept="image/*" hidden
                        onChange={(e) => handleFile(e.target.files?.[0])} />
                    <button
                        type="button"
                        onClick={() => inputRef.current?.click()}
                        disabled={uploading}
                        className="inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-lg border border-slate-200 hover:bg-slate-50 disabled:opacity-50"
                    >
                        {uploading ? <Loader2 size={13} className="animate-spin" /> : <Upload size={13} />}
                        {value ? 'Replace image' : 'Upload image'}
                    </button>
                    {value && (
                        <button type="button" onClick={() => onChange('')} className="ml-2 text-xs text-slate-400 hover:text-red-500 inline-flex items-center gap-1">
                            <X size={12} /> Remove
                        </button>
                    )}
                </div>
            </div>
            {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
        </div>
    );
}